import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { NavLink as Link } from 'redux-first-router-link';
import { withTranslation } from 'react-i18next';
import { Container, Row } from 'reactstrap';
import _, { get, isEmpty } from 'lodash';
import ToolbarButton from './toolbar-button/toolbarButton.js';
import GlobalNavigation from './mdt-global-nav/mdt-global-nav.js';
import HospitalSwitch from './mdt-toolbar-hospital/mdt-toolbar-hospital.js';
import UserProfileModal from './mdt-toolbar-profile/mdt-toolbar-profile.js';
import HelpToolbar from './mdt-toolbar-profile/mdt-toolbar-help.js';
import UserCartCount from './mdt-user-cart-count/mdt-user-cart-count.js';
import LanguageSelector from './languageSelector/index.js';
import ThemeSelector from './themeSelector/index.js';
import { sendEventTrackingData } from '../../../../helpers/commonUtils.js';
import { NotificationIcon } from '../../../atoms/mdt-iconset/index.js';
import * as MeActions from '../../../../actions/MeActions.js';
import { MDTApp } from '../../../../actions/bootAction.js';
import MDTContext from '../../../../helpers/contextHelper.js';
import MDTBreadcrumb from '../../mdt-breadcrumb/index.js';
import {
    getConsumptionCart,
    hasInventoryCartType,
} from '../../../../actions/inventoryCoreActions.js';
import './headerToolbar.css';

const MDTHeaderToolbar = (props) => {
    const {
        t,
        loginStatus,
        applyOnboarding,
        returnsCartCount,
        navigateToReturns,
        getResourceAccess,
        breadCrumbConfig,
        breadCrumbOnPageClick,
        useReturnWizard,
        inventoryCartType,
        inventoryCartCount,
        userDetails,
    } = props;

    const [selLanguage, setSelectedLanguage] = useState({});
    const [languageSelectorObj, setLanguageSelectorObj] = useState({});
    const { MDTSetting } = window;
    const hasInventoryOrBillReplaceAccess =
        getResourceAccess('Inventory', 'Read') ||
        getResourceAccess('Inventory', 'Write') ||
        getResourceAccess('BillAndReplace', 'Read') ||
        getResourceAccess('BillAndReplace', 'Write');

    useEffect(() => {
        if (
            props.loginStatus &&
            !props.applyOnboarding &&
            MDTApp.getSetting('login.fetchCustomer', true) &&
            _.isEmpty(props.customer)
        ) {
            props.getCustomersList();
            hasInventoryOrBillReplaceAccess && props.getInventoryCart();
        }
    }, []);

    const onLogoClick = () => {
        const eventParamObj = {
            eventCategory: 'globalHeader',
            eventAction: 'logo',
            eventLabel: 'logoClicked',
        };
        sendEventTrackingData(eventParamObj);
    };

    const languageSelectorData = (childData, selectedLanguage) => {
        setLanguageSelectorObj(childData);
        setSelectedLanguage(selectedLanguage);
    };

    const viewCart = !!getResourceAccess('Cart', 'Write');
    const viewReturns =
        getResourceAccess('Returns', 'Read') && getResourceAccess('ReturnProducts', 'Feature');
    const showLoggedInMenu = loginStatus && !applyOnboarding && !isEmpty(userDetails);
    const getInventoryRoutePath = () =>
        getResourceAccess('Inventory', 'Read') || getResourceAccess('Inventory', 'Write')
            ? navigateToReturns('CONSUMPTIONSUMMARY')
            : navigateToReturns('BILLANDREPLACE');

    const navMenuProp = {
        t,
        pageName: props.pageName,
        loggedIn: showLoggedInMenu,
    };

    const logoPath = MDTSetting.layout.toolbar.logo;

    const showHelpIcon =
        typeof MDTSetting.layout.toolbar.helpIcon === 'boolean'
            ? MDTSetting.layout.toolbar.helpIcon
            : true;

    const isThemeSelectorEnabled =
        typeof MDTSetting.features.isThemeSelectorEnabled === 'boolean'
            ? MDTSetting.features.isThemeSelectorEnabled
            : false;
    return (
        <header data-test='mdHeaderToolbar' className='mdttoolbar'>
            {/* Top Bar */}
            <div className='mdttoolbar-nav'>
                <Container className='my-0'>
                    <Row className='mx-0'>
                        {/* Logo Section */}
                        <div className='mdttoolbar-nav-logo d-sm-block' data-test='logo'>
                            <Link
                                onClick={onLogoClick}
                                to={{ type: isEmpty(userDetails) ? 'LOGIN' : 'HOME' }}
                            >
                                <img alt='Medtronic Logo' src={logoPath} />
                            </Link>
                        </div>

                        {/* Right Div Utility Icons */}
                        <div className='nav'>
                            <ToolbarButton className='d-none d-sm-block'>
                                {isThemeSelectorEnabled && <ThemeSelector />}
                            </ToolbarButton>
                            {/* Language Selector Toolbar */}
                            <ToolbarButton
                                className='d-none d-sm-block'
                                dataTest='language-selector'
                            >
                                <LanguageSelector
                                    t={t}
                                    langugaeSelectorCallBack={languageSelectorData}
                                />
                            </ToolbarButton>

                            {/* User Profile Toolbar */}
                            {showLoggedInMenu && (
                                <ToolbarButton
                                    className='mdt-toolbar-profile d-none d-sm-block'
                                    dataTest='user-profile'
                                >
                                    <UserProfileModal className='toolbar-profile' t={t} />
                                </ToolbarButton>
                            )}
                            {showLoggedInMenu && showHelpIcon && (
                                <ToolbarButton
                                    className='mdt-toolbar-profile d-none d-sm-block'
                                    dataTest='help-toolbar'
                                >
                                    <HelpToolbar className='toolbar-profile' t={t} />
                                </ToolbarButton>
                            )}

                            {/* ReturnCart Toolbar */}
                            {showLoggedInMenu &&
                                returnsCartCount > 0 &&
                                viewReturns &&
                                MDTApp.getSetting('login.autofetchWishlist', true) && (
                                    <ToolbarButton dataTest='return-cart-toolbar'>
                                        <NotificationIcon
                                            iconCount={returnsCartCount}
                                            iconEmpty='icon_return'
                                            iconWhenNotification='icon_return'
                                            onIconClicked={() =>
                                                navigateToReturns(
                                                    !!useReturnWizard
                                                        ? 'RETURNCHECKOUT'
                                                        : 'RETURNCART'
                                                )
                                            }
                                        />
                                    </ToolbarButton>
                                )}

                            {/* InventoryCart Toolbar */}
                            {showLoggedInMenu &&
                                inventoryCartCount > 0 &&
                                hasInventoryCartType(inventoryCartType) &&
                                MDTApp.getSetting('login.autofetchWishlist', true) && (
                                    <ToolbarButton dataTest='inventory-cart-toolbar'>
                                        <NotificationIcon
                                            iconCount={inventoryCartCount}
                                            iconEmpty='Inventory-Cart'
                                            iconWhenNotification='Inventory-Cart'
                                            onIconClicked={() => getInventoryRoutePath()}
                                        />
                                    </ToolbarButton>
                                )}

                            {/* Cart Toolbar */}
                            {showLoggedInMenu &&
                                viewCart &&
                                MDTApp.getSetting('login.autofetchWishlist', true) && (
                                    <ToolbarButton dataTest='cart-toolbar'>
                                        <UserCartCount className='user-cart-count' t={t} />
                                    </ToolbarButton>
                                )}
                        </div>
                    </Row>
                </Container>
            </div>

            {/* Navigation and Customer Dropdown Bar */}
            <div className='mdttoolbar-nav blue-stripe'>
                <Container className='my-0'>
                    <Row className='toolbar'>
                        {/* Menu */}
                        <ToolbarButton className='mdt-toolbarNav' dataTest='menu'>
                            <MDTContext.Provider
                                value={{
                                    languageSelectorData: languageSelectorObj,
                                    selectedLanguage: selLanguage,
                                }}
                            >
                                <GlobalNavigation {...navMenuProp} />
                            </MDTContext.Provider>
                        </ToolbarButton>

                        {/* Customer Dropdown */}
                        {showLoggedInMenu && MDTApp.getSetting('login.fetchCustomer', true) && (
                            <ToolbarButton
                                className='mdt-hospital-switch'
                                dataTest='customer-dropdown'
                            >
                                <HospitalSwitch
                                    prefCustomer={props.prefCustomer}
                                    customer={props.customer}
                                    t={t}
                                    className='toolbar-hospital'
                                    maxnamelength='52'
                                />
                            </ToolbarButton>
                        )}
                    </Row>
                </Container>
            </div>
            {MDTApp.getSetting('breadCrumb.active', false, false) &&
                breadCrumbConfig &&
                breadCrumbOnPageClick && (
                    <MDTBreadcrumb
                        t={t}
                        config={breadCrumbConfig}
                        onPageClick={breadCrumbOnPageClick}
                    />
                )}
        </header>
    );
};

const mapStateToProps = (state) => {
    let customerList = {};
    let prefCustomer = {};

    try {
        if (!_.isEmpty(state.meDetails.manageCustomerList.customers)) {
            customerList = state.meDetails.manageCustomerList.customers;
            prefCustomer = state.meDetails.customerPreferences;
        }
    } catch (err) {
        customerList = {};
    }

    return {
        customer: customerList,
        prefCustomer,
        loginStatus: state.meDetails.meState.LOGGED_IN,
        applyOnboarding: state.meDetails.meState.APPLY_ONBOARDING,
        pageName: state.page,
        returnsCartCount: get(state, 'returnsReducer.returnsCartCount', 0),
        useReturnWizard: get(
            state,
            'formConfig.featureConfiguration.ReturnCheckoutFlow.configuration.useReturnWizard',
            false
        ),
        inventoryCartType: get(state, 'inventoryCoreReducer.cartType', ''),
        inventoryCartCount: get(state, 'inventoryCoreReducer.cartProductCount', 0),
        userDetails: get(state, 'meDetails.user', {}),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getCustomersList: () => dispatch(MeActions.getCustomers()),
        getThemeChange: (theme) => dispatch(MeActions.themeUpdate(theme)),
        getResourceAccess: (resource, action) =>
            dispatch(MDTApp.getResourceAccess(resource, action)),
        navigateToReturns: (path) => dispatch({ type: path }),
        getInventoryCart: () => dispatch(getConsumptionCart()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(MDTHeaderToolbar));
